import React from "react";
import LoginBox from "../components/LoginBox";

const Login = () => {
  return <LoginBox />;
};

export default Login;
